var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBluePhone = function SvgBluePhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_677116_cc",
    width: 12.376,
    height: 13.171,
    viewBox: "0 0 12.376 13.171",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M14.12,15.979a6.36,6.36,0,0,0,.765-.045l.143-.018.084-.111a5.026,5.026,0,0,0,.7-3.265l0-.147-.115-.1a2.872,2.872,0,0,0-2.6-.967h-.108l-.087.062a6.814,6.814,0,0,0-1.435.9,11.073,11.073,0,0,1-2.919-1.973,10.284,10.284,0,0,1-1.7-2.577c.5-.249.768-.77,1.1-1.053l.08-.069.022-.1a4.387,4.387,0,0,0-.579-3.484L7.4,2.91l-.153-.024a6.029,6.029,0,0,0-3.4.439l-.131.057-.046.13c-.6,1.693-.135,4.827,2.968,8.56C9.633,15.412,12.512,15.979,14.12,15.979Z",
    transform: "translate(-3.439 -2.808)",
    fill: "#07a3c8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBluePhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bluePhone.181954dc.svg";
export { ForwardRef as ReactComponent };